<template>
    <div>
      <div class="container-fluid bg-light py-6 mt-0">
        <div class="container text-center animated bounceInDown">
          <h1 class="display-1 mb-4">{{ $t('studentMessage') }}</h1>
          <ol
            class="breadcrumb justify-content-center mb-0 animated bounceInDown"
          >
            <li class="breadcrumb-item"><a href="#">{{ $t('home') }}</a></li>
            <li class="breadcrumb-item text-dark" aria-current="page">{{ $t('studentMessage') }}</li>
          </ol>
        </div>
      </div>
      <div class="container">
      <div  v-for="person in persons" :key="person.id" class="row g-5 mt-3 p-1">
        <div class="col-lg-4 wow bounceInUp" data-wow-delay="0.1s">
            <img :src="getImageUrl(person.person_image_url)" class="img-fluid rounded" alt=""  style="max-height: 300px;"/>
        </div>
        <div class="col-lg-8 wow bounceInUp" data-wow-delay="0.3s">
          <small
            class="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3"
            >{{ $t('studentMessage') }}</small
          >
          <h1 class="display-5 mb-4">{{ person.name }}</h1>
          <p class="mb-4">
           {{ person.description }}
          </p>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import mediaUrl from "../utils/mediaUrl";

  export default {
   computed: mapGetters(["persons"]),
   methods : {
    ...mapActions(['getStudent']),
    getImageUrl(imageUrl) {
      return mediaUrl(imageUrl);
    },
   },
    mounted() {
      this.getStudent()
      console.log(this.persons)
    }
  }
  </script>
  
  <style>
  
  </style>